<div class="project-status-controls">
  <!-- <button class="collapse-btn" (click)="toggleTabContent()" [class.collapsed]="!isTabContentVisible">
    <img src="assets/images/pr-ham.png" alt="Collapse">
  </button> -->

   @if (isTabContentVisible) {
  <div class="tabs-container">
    <div class="tab" [class.active]="selectedTab === 'hours'" (click)="selectTab('hours')">
      <i class="wl_icon_Time-Summary"></i>
      <p>Time Summary</p>

    </div>
    <div class="tab" [class.active]="selectedTab === 'other'" (click)="selectTab('other')">
      <i class="wl_icon_Notes"></i>
      <p>Notes</p>
    </div>
  </div>
  }
</div>

<!-- Tab content -->
 @if (isTabContentVisible) {
<div class="tab-content">
  @if (selectedTab === 'hours') {
  <div class="hour-tab">
    <div class="hour-tab">
      <div class="status-card">
        <h3 class="project-hours-status-title">Project Hours And Status</h3>

        <div class="status-container">
          <div class="chart-section">
            <!-- Project Status -->
            <div class="donut-container proj_stat_donut">
              <div class="gauge-wrapper">
                <div #projectStatusChartContainer class="gauge-chart"></div>
                <!-- Loading spinner overlay -->
                 @if (isChartsLoading) {
                <div class="spinner-only">
                  <app-spinner [size]="20"></app-spinner>
                </div>
                }
              </div>
              <div class="caption">Project Status</div>
            </div>

            <!-- Balance Hours -->
            <div class="donut-container filled_hrs_donut">
              <div #balanceHoursChartContainer class="gauge-chart"></div>
              <!-- Loading spinner overlay -->
               @if (isChartsLoading) {
              <div class="spinner-only">
                <app-spinner [size]="20"></app-spinner>
              </div>
              }
            </div>
          </div>

          <div class="info-section">

            <ul class="stats">
              <li class="light"><span>Planned Hours :</span> <b>{{ projectHourStatus()?.totalPlannedHours ?? '-' }}</b>
              </li>
              <li class="green"><span>Hours Filled :</span> <b>{{ projectHourStatus()?.hourFilledData ?? '-' }}</b></li>
              <li class="blue"><span>Unfilled Hours :</span> <b>{{ projectHourStatus()?.unfilledHours ?? '-' }}</b></li>
              <li class="pink"><span>Offset Hours :</span> <b>{{ projectHourStatus()?.offsetHours ?? '-' }}</b></li>
            </ul>
          </div>
        </div>
      </div>


      <div class="user-input-card">
        <div class="card-title">
          User Input Hours <span class="total">({{ formatHours(projectHourData()?.totalBillableHours) }})</span>
        </div>

        <div class="section">
          <div class="section-header billable">
            <span>Billable</span>
            <b>{{ formatHours(projectHourData()?.totalBillableHours) }}</b>
          </div>
          <div class="row"><span>Task</span><span>{{ formatHours(projectHourData()?.totalTaskHours) }}</span></div>
          <div class="row"><span>Project</span><span>{{ formatHours(projectHourData()?.totalProjectHours) }}</span>
          </div>
          <div class="row"><span>Request</span><span>{{ formatHours(projectHourData()?.totalRequestHours) }}</span>
          </div>
          <div class="row"><span>Revisions</span><span>{{ formatHours(projectHourData()?.totalRevisionHours) }}</span>
          </div>
        </div>

        <div class="section">
          <div class="section-header non-billable">
            <span>Non Billable</span>
            <b>{{ formatHours(projectHourData()?.totalNonBillableHours) }}</b>
          </div>
          <div class="row"><span>Issue</span><span>{{ formatHours(projectHourData()?.totalIssueHours) }}</span></div>
          <div class="row"><span>Offset Hours</span><span>{{ formatHours(projectHourData()?.totalOffsetHours) }}</span>
          </div>
        </div>
      </div>

      @if (!HideCompletionDateCard()) {
      <div class="goal-date-card">
        <div class="goal-date-top">
          <div class="goal-date-label">
            Completion Date
             @if (goalDateTooltipRows()[0]?.responsibility) {
            <span #hintIconWrapper class="hint-icon-wrapper" tabindex="0"
              (mouseenter)="onGoalDateHintEnter()"
              (mouseleave)="onGoalDateHintLeave()" (focus)="onGoalDateHintEnter()" (blur)="onGoalDateHintLeave()">
              <i class="wl_icon_hint hint-icon"></i>
            </span>
            }
            @if (showGoalDateTooltip) {
            <div #goalDateTooltip class="goal-date-tooltip new-format completion-log-tooltip"
              [ngClass]="{ 'invisible': !tooltipPositioned }"
              (mouseenter)="onGoalDateHintEnter()" (mouseleave)="onGoalDateHintLeave()">
              <div class="completion-log-tooltip__header">PROJECTED COMPLETION LOG</div>
              <div class="completion-log-tooltip__body">
                @for (row of goalDateTooltipRows(); track row) {
                <div class="completion-log-tooltip__entry">
                  <div class="completion-log-tooltip__change">
                    <span class="completion-log-tooltip__date">{{ row?.prevProjectedDate | date:'MMM d, y' }}</span>
                    <span class="completion-log-tooltip__arrow" aria-hidden="true">→</span>
                    <span class="completion-log-tooltip__date completion-log-tooltip__date--emphasis">{{
                      row?.currentProjectedDate | date:'MMM d, y' }}</span>
                  </div>
                  <div class="completion-log-tooltip__meta">
                    <span>{{ row?.changedBy?.name }}</span>
                    <span class="completion-log-tooltip__sep">·</span>
                    <span>{{ row?.createdAt | date:'MMM d, h:mm a' }}</span>
                    @if (row?.responsibility) {
                    <span class="completion-log-tooltip__badge">{{ row?.responsibility }}</span>
                    }
                  </div>
                  @if (row?.reason) {
                  <div class="completion-log-tooltip__reason">
                    <span class="completion-log-tooltip__reason-label">Reason:</span>
                    <span class="completion-log-tooltip__reason-text">{{ row?.reason }}</span>
                  </div>
                  }
                </div>
                }
              </div>
            </div>
            }
          </div>
          <div class="goal-date-main">
            <div class="goal-date">
              <span class="goal-day">
                {{ projectsPlannedDateLog()?.currentProjectedDate ? (projectsPlannedDateLog().currentProjectedDate |
                date:'d') : '-' }}
              </span>
              <span class="goal-month">
                {{ projectsPlannedDateLog()?.currentProjectedDate ? (projectsPlannedDateLog().currentProjectedDate |
                date:'MMMM') : '-' }}
              </span>
              @if (!shouldHideCompletionDateEdit()) {
              <div class="datepicker-container">
                <input [matDatepicker]="datepicker" name="goalDate" [(ngModel)]="selectedGoalDate"
                  (ngModelChange)="onDateChange()" class="datepicker-input" readonly>
                <button mat-icon-button class="edit-icon" (click)="openProjectCompletionModal()">
                  <i class="wl_icon_edit_btn"></i>
                </button>
                <!-- <mat-datepicker #datepicker (closed)="onDateChange()"></mat-datepicker> -->
              </div>
              }
            </div>
          </div>
        </div>

        <div class="goal-date-bottom">
          <div class="meta-item">
            <span class="meta-label">Changed on</span>
            <span class="meta-value link" [matTooltip]="projectsPlannedDateLog()?.updatedAt ? (projectsPlannedDateLog().updatedAt | date:'MMM d, y') : '-'" matTooltipPosition="above">
              {{ projectsPlannedDateLog()?.updatedAt ? (projectsPlannedDateLog().updatedAt | date:'MMM d, y') : '-' }}
            </span>
          </div>
          <div class="meta-item">
            <span class="meta-label">Changed by</span>
            <span class="meta-value link" [matTooltip]="projectsPlannedDateLog()?.changedBy?.name ?? '-'" matTooltipPosition="above">{{projectsPlannedDateLog()?.changedBy?.name ?? '-' }}</span>
          </div>

          <div class="meta-item">
            <span class="meta-label">Changed to</span>
            <span class="meta-value link" [matTooltip]="projectsPlannedDateLog()?.currentProjectedDate ? (projectsPlannedDateLog().currentProjectedDate | date:'MMM d, y') : '-'" matTooltipPosition="above">
              {{ projectsPlannedDateLog()?.currentProjectedDate ? (projectsPlannedDateLog().currentProjectedDate |
              date:'MMM d, y') : '-' }}
            </span>
          </div>
          <div class="meta-item">
            <span class="meta-label">Responsibility</span>
            <span class="meta-value link" [matTooltip]="projectsPlannedDateLog()?.responsibility ? projectsPlannedDateLog().responsibility : '-'" matTooltipPosition="above">
              {{ projectsPlannedDateLog()?.responsibility ? projectsPlannedDateLog().responsibility : '-' }}
            </span>
            <!-- <div class="meta-value select">
              <ng-select
                [items]="responsibilityOptions"
                bindLabel="name"
                class="custom-ng-select"
                [(ngModel)]="selectedResponsibility"
                (ngModelChange)="onResponsibilityChange($event)"
                [clearable]="false"
                [searchable]="false"
                appendTo="body"
                dropdownPosition="top">
              </ng-select>
            </div> -->
          </div>
        </div>
      </div>
      }
    </div>

  </div>
  }
  @if (selectedTab === 'other') {
  <div>
    <!-- Notes Tab Content -->
    <div class="project-status-container">
      <!-- Loading Spinner for Notes -->
       @if (notesLoading()) {
      <div class="notes-loading-spinner">
        <app-spinner [size]="40"></app-spinner>
      </div>
      }

      <!-- Add New Note Button -->
       @if (!notesLoading()) {
      <button class="add-note-btn" (click)="onAddNoteClick()">
        Add New Note
        <span class="add-icon">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
            <path d="M7 10L12 15L17 10" stroke="white" stroke-width="2" stroke-linecap="round"
              stroke-linejoin="round" />
          </svg>
        </span>
      </button>
      }

      <!-- Add Note Form -->
       @if (showAddNoteForm() && !notesLoading()) {
      <div class="add-note-form">
        <quill-editor
          class="note-input"
          [(ngModel)]="newNoteDraft"
          [modules]="quillConfig"
          placeholder="Enter your note..."
          (onEditorCreated)="onNoteEditorCreated($event)"
          (keydown.control.enter)="addNewNote()"
        ></quill-editor>

        <!-- Selected Files Preview (only show if files are selected) -->
         @if (selectedFiles.length > 0) {
        <div class="selected-files">
          <div class="files-header">
            <span class="files-count">{{ selectedFiles.length }} file(s) selected</span>
            <button class="clear-files-btn" (click)="clearSelectedFiles()" title="Clear all files">
              <i class="fa-solid fa-xmark"></i>
            </button>
          </div>
          <div class="files-list">
            @for (file of selectedFiles; track $index; let i = $index) {
            <div class="file-item">
              <div class="file-info">
                <i [class]="getFileIcon(file.type)" class="file-icon"></i>
                <div class="file-details">
                  <span class="file-name">{{ file.name }}</span>
                  <span class="file-size">{{ formatFileSize(file.size) }}</span>
                </div>
              </div>
              <button class="remove-file-btn" (click)="removeFile(i)" title="Remove file">
                <i class="fa-solid fa-xmark"></i>
              </button>
            </div>
            }
          </div>
        </div>
        }

        <div class="form-actions">
          <button class="btn-save" (click)="addNewNote()"
            [disabled]="(!newNoteDraft.trim() && selectedFiles.length === 0) || addNoteLoading()">
            @if (addNoteLoading()) {
            <app-spinner [size]="16"></app-spinner>
            } @else {
            Save
            }
          </button>
          <button class="btn-cancel" (click)="cancelAddNote()" [disabled]="addNoteLoading()">
            Cancel
          </button>
        </div>
      </div>
      }

      <!-- Notes List -->
       @if (!notesLoading()) {
      <div>
        @for (note of sortedNotes(); track note.id; let i = $index) {
        <div class="note-card" [class.pinned]="note.isPinned"
          [class.is-editing]="isEditingNote(note.id)"
          [style.background]="getCardBackgroundColor(i)" [style.border-color]="getCardBorderColor(i)">
          <!-- Dynamic pinned overlay -->
           @if (note.isPinned) {
          <div class="pinned-overlay" [style.background]="getPinnedOverlayColor(i)">
          </div>
          }

          <div class="note-header">
            <!-- <button class="pin-btn" (click)="togglePin(note.id)" [class.pinned]="note.isPinned"
            [title]="note.isPinned ? 'Unpin note' : 'Pin note'">
            <i class="wl_icon_pin" [ngClass]="note.isPinned ? 'pinned' : 'unpinned'"></i>
          </button> -->
            <button class="close-btn" (click)="deleteNote(note.id)" matTooltip="Delete Note">
              <i class="wl_icon_delete"></i>
            </button>
          </div>

          <div class="note-content">
            <!-- Edit Mode -->
            @if (isEditingNote(note.id)) {
            <div class="edit-mode">
              <quill-editor
                class="note-edit-input"
                [(ngModel)]="editNoteDraft"
                [modules]="quillConfig"
                #editInput
                (onEditorCreated)="onNoteEditorCreated($event)"
                (keydown.control.enter)="saveEditNote(note.id)"
                (keydown.escape)="cancelEditNote()"
              ></quill-editor>
              <div class="edit-actions">
                <button class="btn-save" (click)="saveEditNote(note.id)" [disabled]="editNoteLoading()">
                  @if (editNoteLoading()) {
                  <app-spinner [size]="16"></app-spinner>
                  } @else {
                  Save
                  }
                </button>
                <button class="btn-cancel" (click)="cancelEditNote()" [disabled]="editNoteLoading()">
                  Cancel
                </button>
              </div>
            </div>
            }

            <!-- View Mode -->
             @if (!isEditingNote(note.id)) {
            <div class="view-mode">
              @if (hasTextContent(note.text)) {
              <div class="note-text-content-wrap">
                <div
                  class="note-text-content"
                  [class.truncated]="!isExpandedNoteContent(note.id) && shouldShowReadMoreForNote(note)"
                  [innerHTML]="getDisplayHtmlForNote(note)"
                ></div>
                @if (shouldShowReadMoreForNote(note)) {
                <div class="read-more-toggle-wrapper">
                  <button
                    type="button"
                    class="read-more-toggle"
                    [class.expanded]="isExpandedNoteContent(note.id)"
                    (click)="toggleNoteReadMore(note.id, $event)"
                    [attr.aria-expanded]="isExpandedNoteContent(note.id)"
                    [attr.aria-label]="isExpandedNoteContent(note.id) ? 'Read less' : 'Read more'"
                  >
                    {{ isExpandedNoteContent(note.id) ? 'Read less' : 'Read more' }}
                  </button>
                </div>
                }
              </div>
              }

              <!-- Video Documents -->
               @if (getVideoDocuments(note).length > 0) {
              <div class="note-meta">
                <div class="audio-list">
                  @for (videoDoc of getVideoDocuments(note); track videoDoc.url || videoDoc.name) {
                  <div class="audio-row">
                    <button class="audio-btn" (click)="openFilePreview(note, videoDoc)"
                      [title]="'Preview ' + videoDoc.name">
                      <i class="wl_icon_doc-video"></i>
                    </button>
                    <div class="audio-info">
                      <span class="audio-name">{{ videoDoc.name }}</span>
                      <span class="audio-time">{{ note.time || '00:00' }}</span>
                    </div>
                  </div>
                  }
                </div>
              </div>
              }

              <!-- Audio Documents -->
              @if (getAudioDocuments(note).length > 0) {
              <div class="note-meta">
                <div class="audio-list">
                  @for (audioDoc of getAudioDocuments(note); track audioDoc.url || audioDoc.name) {
                  <div class="audio-row">
                    <button class="audio-btn" (click)="openFilePreview(note, audioDoc)"
                      [title]="'Preview ' + audioDoc.name">
                      <i class="wl_icon_doc-video"></i>
                    </button>
                    <div class="audio-info">
                      <span class="audio-name">{{ audioDoc.name }}</span>
                      <span class="audio-time">{{ note.time || '00:00' }}</span>
                    </div>
                  </div>
                  }
                </div>
              </div>
              }

              <!-- Image Documents -->
               @if (getImageDocuments(note).length > 0) {
              <div class="note-meta1">
                <div class="images-container">
                  @for (imageDoc of getImageDocuments(note); track imageDoc.url || imageDoc.name; let i = $index) {
                  <div class="image-item">
                    <div class="image-preview-container" (click)="openFilePreview(note, imageDoc)"
                      [title]="'Preview ' + imageDoc.name">
                      <img [src]="imageDoc.url" [alt]="imageDoc.name || 'Image preview'" class="image-thumbnail"
                        [class.hidden-thumbnail]="!isImageThumbnailLoaded(note.id + '_' + i)"
                        (error)="onImageThumbnailError($event, note.id + '_' + i)"
                        (load)="onImageThumbnailLoad($event, note.id + '_' + i)" #imageThumbnail
                        (click)="openFilePreview(note, imageDoc)" [attr.data-note-id]="note.id + '_' + i">
                        @if (!isImageThumbnailLoaded(note.id + '_' + i)) {
                      <button class="image-btn"
                        (click)="openFilePreview(note, imageDoc)" [title]="'Preview ' + imageDoc.name">
                        <i class="wl_icon_img-icon"></i>
                      </button>
                      }
                    </div>
                    <span class="image-name" [matTooltip]="imageDoc.name">{{ imageDoc.name }}</span>
                  </div>
                  }
                </div>
              </div>
              }

              <!-- Document Files -->
               @if (getDocumentFiles(note).length > 0) {
              <div class="note-meta1">
                <div class="documents-container">
                  @for (docFile of getDocumentFiles(note); track docFile.url || docFile.name) {
                  <button class="document-btn"
                    (click)="openFilePreview(note, docFile)" [title]="'Open ' + docFile.name">
                    <i [class]="getDocumentIcon(docFile.type)"></i>
                    <span class="document-name">{{ docFile.name }}</span>
                  </button>
                  }
                </div>
              </div>
              }

              <div class="note-footer-actions">
                <div class="note-footer">{{ note.user }} | {{ note.date }}</div>
                <!-- <button class="edit-note-btn" (click)="startEditNote(note.id)" title="Edit note">
                <i class="wl_icon_edit"></i>
              </button> -->
              </div>
            </div>
            }
          </div>
        </div>
        }
      </div>
      }

      <!-- No Data State -->
       @if (sortedNotes().length === 0 && !notesLoading()) {
      <div class="no-data-container">
        <div class="no-data-content">
          <mat-icon class="no-data-icon">description</mat-icon>
          <h3 class="no-data-title">No Notes Available</h3>
          <p class="no-data-message">There are no notes for this project yet. Click "Add New Note" to create your first
            note.</p>
        </div>
      </div>
      }
    </div>

  </div>
  }
</div>
}

<!-- Project Completion Modal Slider -->
 @if (showProjectCompletionSlider()) {
<app-project-completion-modal [modalData]="projectCompletionModalData()"
  (modalClosed)="onProjectCompletionModalClosed()" (formSubmitted)="onProjectCompletionFormSubmitted($event)">
</app-project-completion-modal>
 }

<app-confirm-popup [show]="showDeleteConfirmPopup()" [title]="'Delete Note'"
  [message]="'Are you sure you want to delete this note? This action cannot be undone.'" [confirmText]="'Delete'"
  [cancelText]="'Cancel'" [type]="'delete'" [loading]="deleteNoteLoading()" (confirm)="onDeleteConfirm()"
  (cancel)="onDeleteCancel()">
</app-confirm-popup>

<!-- File Preview Modal -->
 @if (showFilePreview()) {
<div class="file-preview-modal" (click)="closeFilePreview()">
  <div class="file-preview-backdrop"></div>

  <div class="file-preview-container" (click)="$event.stopPropagation()">
    <!-- Modal Header -->
    <div class="file-preview-header">
      <div class="file-info">
        <div class="file-details">
          <h3 class="file-name">{{ currentFilePreview()?.fileName }}</h3>
          <span class="file-type">{{ currentFilePreview()?.fileType }}</span>
        </div>
      </div>
      <div class="file-actions">
        <button class="action-btn download-btn" (click)="downloadFile($event)" title="Download file">
          <i class="fas fa-download"></i>
        </button>
        <button class="action-btn close-btn" (click)="closeFilePreview()" title="Close preview">
          <i class="fas fa-times"></i>
        </button>
      </div>
    </div>

    <!-- Modal Body -->
    <div class="file-preview-body">
      <!-- Image Preview -->
       @if (currentFilePreview()?.type === 'image') {
      <div class="image-preview">
        <img [src]="currentFilePreview()?.fileUrl" [alt]="currentFilePreview()?.fileName" class="preview-image">
      </div>
      }

      <!-- Video Preview -->
       @if (currentFilePreview()?.type === 'video') {
      <div class="video-preview">
        <video [src]="currentFilePreview()?.fileUrl" controls class="preview-video" controlsList="nodownload">
          Your browser does not support the video tag.
        </video>
      </div>
      }

      <!-- Audio Preview -->
       @if (currentFilePreview()?.type === 'audio') {
      <div class="audio-preview">
        <div class="audio-player-wrapper">
          <i class="wl_icon_doc-video audio-icon"></i>
          <audio [src]="currentFilePreview()?.fileUrl" controls class="preview-audio" controlsList="nodownload">
            Your browser does not support the audio tag.
          </audio>
        </div>
      </div>
      }

      <!-- Document Preview -->
      <!-- <ng-container *ngIf="currentFilePreview()?.type === 'document'"> -->
        @if (currentFilePreview()?.type === 'document') {
        @if (currentFilePreview(); as preview) {
        <div class="document-preview">
          @if (preview.fileType && preview.fileType.includes('pdf')) {
          <iframe [src]="preview.fileUrl" class="preview-document">
          </iframe>
          }
          @if (!preview.fileType || !preview.fileType.includes('pdf')) {
          <div class="document-placeholder">
            <i class="wl_icon_doc-export placeholder-icon"></i>
            <p>Document preview not available</p>
            <button class="download-document-btn" (click)="downloadFile($event)">
              <i class="fas fa-download"></i>
              Download to view
            </button>
          </div>
          }
        </div>
      <!-- </ng-container> -->
      }
    }
    </div>
  </div>
</div>
}